<template>
  <div class="app-container">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="品牌">
          <el-select
            v-model="queryForm.carBrandId"
            placeholder="--选择品牌--"
            filterable
            clearable
            remote
            :remote-method="getMakeList"
          >
            <el-option
              v-for="item in MakeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="id"
            label="型号"
            key="id"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="carBrandName"
            label="品牌"
            key="carBrandName"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="name"
            label="型号"
            key="name"
            :show-overflow-tooltip="true"
          />
          <el-table-column width="150" prop fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="bj(scope.$index, scope.row)" size="small"
                >编辑</el-button
              >
              <el-button @click="sc(scope.$index, scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改"
      :visible.sync="editData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="editClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="品牌：" prop="carBrandId">
          <el-select
            v-model.trim="editForm.carBrandId"
            filterable
            clearable
            remote
            :remote-method="getMakeList"
            placeholder="--选择品牌--"
          >
            <el-option
              v-for="item in MakeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="型号：" prop="name">
          <el-input v-model.trim="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="价格等级：" prop="type">
          <el-select
            v-model.trim="editForm.type"
            placeholder="--选择价格等级--"
          >
            <el-option
              v-for="(item, index) in priceLevel"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="editUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="品牌：" prop="carBrandId">
          <el-select
            v-model.trim="newForm.carBrandId"
            filterable
            clearable
            remote
            :remote-method="getMakeList"
            placeholder="--选择品牌--"
          >
            <el-option
              v-for="item in MakeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="型号：" prop="name">
          <el-input v-model.trim="newForm.name"></el-input>
        </el-form-item>
        <el-form-item label="价格等级：" prop="type">
          <el-select v-model.trim="newForm.type" placeholder="--选择价格等级--">
            <el-option
              v-for="(item, index) in priceLevel"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { carModel, carBrand } from "../axios/api";
export default {
  data() {
    return {
      MakeList: [], // 品牌
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      editData: false,
      editForm: {
        carBrandId: null,
        name: "",
        type: null,
      },
      newData: false,
      newForm: {
        carBrandId: null,
        name: "",
        type: null,
      },
      queryForm: {
        carBrandId: null,
      },
      rules: {
        carBrandId: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入型号", trigger: "blur" }],
        type: [{ required: true, message: "请输入价格等级", trigger: "blur" }],
      },
      tableData: [],
      priceLevel: [1, 2, 3, 4, 5, 6, 7, 8, 9], // 价格等级
    };
  },
  methods: {
    // 获取品牌
    getMakeList(query) {
      let that = this;
      var data = {
        pageSize: 10,
        pageNumber: 1,
        name: query || undefined,
      };

      carBrand
        .getTable(data)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;

            // 品牌
            that.MakeList = list;
          }
        })
        .catch(function (error) {});
    },
    search() {
      this.currentPage = 1;
      this.init();
    },
    reset() {
      this.queryForm.carBrandId = "";
      this.currentPage = 1;
      this.init();
    },
    add() {
      this.newForm = {};
      this.newData = true;

      this.getMakeList(); // 获取品牌
    },
    newClose() {
      this.$refs["newForm"].clearValidate();
      this.newData = false;

      this.getMakeList(); // 获取品牌
    },
    newCancel() {
      this.$refs["newForm"].clearValidate();
      this.newData = false;

      this.getMakeList(); // 获取品牌
    },
    newUpdate() {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          let data = {
            name: that.newForm.name, // 型号
            carBrandId: that.newForm.carBrandId, // 品牌
            type: that.newForm.type,
          };
          // console.log(data)
          // return
          carModel
            .addTable(JSON.stringify(data))
            .then((res) => {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("添加成功!");
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.init();
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },

    current_change(currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    bj(index, row) {
      console.log(row);
      var that = this;
      // editForm是Dialog弹框的data
      that.editForm = Object.assign({}, row);
      that.editData = true; //显示弹框

      that.MakeList = [
        {
          id: row.carBrandId,
          name: row.carBrandName,
        },
      ];
    },
    editClose() {
      this.$refs["editForm"].clearValidate();
      this.editData = false;

      this.getMakeList(); // 获取品牌
    },
    editCancel() {
      this.$refs["editForm"].clearValidate();
      this.editData = false;

      this.getMakeList(); // 获取品牌
    },
    editUpdate() {
      var that = this;
      that.$refs["editForm"].validate((valid) => {
        if (valid) {
          let data = {
            name: that.editForm.name,
            carBrandId: that.editForm.carBrandId,
            type: that.editForm.type,
          };
          carModel
            .editTable(data, that.editForm.id)
            .then((res) => {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("更新成功!");
                that.editData = false;
                that.$refs["editForm"].clearValidate();
                that.init();
              }
            })
            .catch(function (error) {
              that.$alert(error.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },
    sc(index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          carModel
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (error) {
              that.$message({
                type: "info",
                message: error.message,
              });
            });
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "已取消删除",
            type: "info",
            duration: 2000,
          });
        });
    },
    init() {
      var that = this;
      //获取汽车列表
      let data = {
        carBrandId: that.queryForm.carBrandId
          ? that.queryForm.carBrandId
          : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };
      carModel
        .getTable(data)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list, totalNumber } = res.data;
            that.total = totalNumber;
            that.tableData = list;
          }
        })
        .catch(function (res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });

      this.getMakeList(); // 获取品牌
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/CarModel.vue